<template>
  <div class="maintenance">
    <div class="maintenance-content">
      <h1 class="brand">EDIFIER</h1>
      
      <p class="message">
        Sitio en mantenimiento<br>
        Volveremos pronto.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Maintenance",
};
</script>

<style lang="scss" scoped>
.maintenance {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.maintenance-content {
  text-align: center;
}

.brand {
  font-family: 'Lato', sans-serif;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 0.3em;
  color: #00A0E9;
  margin: 0 0 32px 0;
}

.message {
  font-family: 'Lato', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  color: #666;
  line-height: 1.8;
  margin: 0;
}
</style>
